<template>
  <div class="widget-balance">
    <div class="widget-balance__value">
      {{ $t('payment.widget.balance.title', { value: get_balance }) }}
    </div>
    <i-button
      v-if="is_shown"
      type="success"
      size="large"
      class="widget-balance__button"
      @click="redirect"
    >
      {{ $t('payment.widget.balance.button') }}
    </i-button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        is_shown: true
      };
    },
    computed: {
      get_balance() {
        const userBalance = Number.parseFloat(this.$user.balance);

        if (!Number.isInteger(userBalance)) {
          return this.$numeral.currency(userBalance.toFixed(2));
        }

        return this.$numeral.currency(userBalance);
      }
    },
    watch: {
      $route: {
        deep: true,
        handler(to) {
          this.is_shown =
            this.$config.available_payment_methods.length > 0 && to.name !== 'core.payment.index';
        }
      }
    },
    created() {
      this.is_shown =
        this.$config.available_payment_methods.length > 0 &&
        this.$route.name !== 'core.payment.index';
    },
    methods: {
      redirect() {
        this.$router.push({ name: 'core.payment.index' });
      }
    }
  };
</script>

<style lang="scss">
  .widget-balance {
    display: inline-block;
    width: 100%;
    text-align: center;

    &__value {
      font-size: 16px;
      margin-bottom: $spacer;
      font-weight: bold;
    }

    &__button {
      height: 40px;
      width: 220px;

      span {
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 1px;
      }
    }
  }
</style>